<template>
  <div class="index">
    <div class="bg">
      <!-- logo -->
      <div class="logo">
        <img
          :src="imgHost + 'logo.png?v=1'"
        />
      </div>
      <!-- slogan -->
      <div class="slogan">
        <img
          :src="imgHost + 'draw_slogan.png?v=2'"
        />
      </div>
      <div class="game_info">
        剩余游戏次数：
        <span>{{gameCounts}}</span>
        次
      </div>
      <div class="turntable-wrapper">
        <div class="luck-wrapper" v-if="myprizeList.length > 0">
          <ul class="nineGrid">
            <li class="row">
              <div v-for="(n, key) in 3" :key="n" :class="index === key ? `active` : ``">
                <div class="wrapper">
                  <img :src="myprizeList[key].prizeIcon + '?v=1.1'" alt />
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li class="row">
              <div :class="index === 7 ? 'active': ''">
                <div class="wrapper">
                  <img :src="myprizeList[7].prizeIcon + '?v=1.1'" alt />
                </div>
                <div class="mask"></div>
              </div>
              <div class="getLuck" @click="startLottery">
                <img :src="imgHost + 'draw-btn.png'" alt />
              </div>
              <div :class="index === 3 ? 'active': ''">
                <div class="wrapper">
                  <img :src="myprizeList[3].prizeIcon + '?v=1.1'" alt />
                </div>
                <div class="mask"></div>
              </div>
            </li>
            <li class="row">
              <div v-for="(n, key) in 3" :key="n" :class="index === 6-key ? `active` : ``">
                <div class="wrapper">
                  <img :src="myprizeList[(6-key)].prizeIcon + '?v=1.1'" alt />
                </div>
                <div class="mask"></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <BasePaySuccess></BasePaySuccess>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
import { MessageBox } from "mint-ui";
export default {
  components: {
  },
  props: {},
  data() {
    return {
      myprizeList: [], //奖品列表
      index: -1, // 当前转动到哪个位置，起点位置
      count: 8, // 总共有多少个位置
      timer: 0, // 每次转动定时器
      speed: 200, // 初始转动速度
      times: 0, // 转动次数
      cycle: 20, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
      prize: -1, // 中奖位置
      gameCounts: 0, //设置抽奖次数
      click: true, //是否禁止抽奖
      prizeId: 0, // 中奖id
    };
  },
  filters: {
  },
  watch: {
  },
  computed: {},
  methods: {
    // 开始抽奖
    startLottery() {
      if (!this.click) {
        return;
      }
      if(this.gameCounts <= 0) {
        this.$modal.drawForm.alert()
        return
      }
      this.initBgm(); //初始化音乐
      // this.startLottery(); //开始抽奖
      window.ConfigAudios.play();
      this.gameCounts--;
      this.speed = 200;
      this.click = false;
      this.startRoll();
    },
    // 开始转动
    startRoll() {
      if (this.click === true) { 
        return
      }
      console.log("======>开始抽奖", 1);
      this.times += 1; // 转动次数
      this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
      // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
      if (this.times > this.cycle + 10 && this.prize === this.index) {
        clearTimeout(this.timer); // 清除转动定时器，停止转动
        this.prize = -1;
        this.times = 0;
        this.click = true;
        this.showToast = true;
      } else {
        if (this.times < this.cycle) {
          this.speed -= 10; // 加快转动速度
        } else if (this.times === this.cycle) {
          // 随机获得一个中奖位置
          this.getLottery();
        } else if (
          this.times > this.cycle + 10 &&
          ((this.prize === 0 && this.index === 7) ||
            this.prize === this.index + 1)
        ) {
          this.speed += 110;
        } else {
          this.speed += 20;
        }

        if (this.speed < 40) {
          this.speed = 40;
        }
        this.timer = setTimeout(this.startRoll, this.speed);
      }
    },
    // 每一次转动
    oneRoll() {
      let index = this.index; // 当前转动到哪个位置
      const count = this.count; // 总共有多少个位置
      index += 1;
      if (index > count - 1) {
        index = 0;
      }
      this.index = index;
    },
    // 抽奖
    async getLottery() {
      console.log("======>调用抽奖接口", 2);
      let that = this;
      that.click = false;
      setTimeout(function () {
        clearTimeout(that.timer); // 清除转动定时器，停止转动
        that.prize = -1;
        that.click = true;
      }, 4000);
      //获取奖品
      const data = await that.$httpdf.get(this.apiHost + 'lucky/prize/lottery')
      if (data.code == 0) {
        this.prizeId = data.data;
        if (that.myprizeList.length > 0) {
          that.myprizeList.forEach(function (v, i) {
            if (v.id == data.data) {
              that.prize = i;
              console.log(that.prize,'prize');
              return;
            }
          });
        }
        setTimeout(() => {
          this.$modal.drawForm.alert({ prizeId: this.prizeId }).then(async ()=> {
            await this.getCount()
            this.getPrize()
            this.getPaySuccess()
          })
        }, 3500);
      } else {
        this.prize = 7;
        setTimeout(()=> {
          MessageBox.alert(data.msg).then(() => {
            this.click = true;
            this.showToast = true;
            this.getPrize();
          });
        }, 2000);
      }
    },
    initBgm() {
      if (!window.ConfigAudios) {
        window.ConfigAudios = new Audio();
        window.ConfigAudios.src =
          "http://assets.rurushishi.com/activies/mfAct/voice.mp3";
        this.$wx.ready(function () {
          window.ConfigAudios.play();
        });
      } else {
        window.ConfigAudios.src =
          "http://assets.rurushishi.com/activies/mfAct/voice.mp3";
        this.$wx.ready(function () {
          window.ConfigAudios.play();
        });
      }
    },
    async getCount() {
      const data = await this.$httpdf.get(this.apiHost + 'user/gameCount')
      if (data.code == 0) {
        this.gameCounts = data.data.gameCount
      } else {
        MessageBox.alert(data.msg).then(()=> {
          this.$goPage("index");
        })
      }
    },
    async getPrize () {
      const data = await this.$httpdf.get(this.apiHost + 'lucky/prize/view')
      if (data.code == 0) {
        let prizeList = {
          prizeName: "谢谢参与",
          prizeIcon: this.imgHost + "9.png",
        }
        this.index = ''
        this.myprizeList = data.data
        this.myprizeList.splice(3, 0, prizeList)
        this.myprizeList.push(prizeList)
      } else {
        MessageBox.alert(data.msg)
      }
    },
    // 跳转活动规则
    goRule() {
      this.$goPage("rules");
    },
  },
  created() {
    this.getCount()
    this.getPrize()
  },
  mounted() {
    console.log(this.$key, this.$mobile, this.$infoId)
    this.$wx.shareCallBackFunList.push("share1", async() => {
      await this.$httpdf.post(this.apiHost + 'share/share');
      this.$modal.share.close()
      this.getCount()
    });
  },
};
</script>
<style lang="scss" scoped>


.index {
  width: 100%;
  overflow-x: hidden;
}

.bg {
  width: 100%;
  min-height: 100vh;
  background: url( $imgHost + 'bg.jpg?t=7') 0 0 / 100% repeat-y;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .logo {
    padding-top: 15px;
    width: $logoWidth;
  }

  .slogan {
    width: 270px;
    position: relative;
    z-index: 2;
    margin-top: 7px;
  }
  .game_info {
    margin-top: 18px;
    width: 191px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 25px;
    text-align: center;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 25px;
    span {
      font-size: 18px;
    }
  }


}

// 抽奖区域
.turntable-wrapper {
  position: relative;
  margin-top: 25px;
  .luck-wrapper {
    width: 326px;
    height: 312px;
    padding: 24px 20px 0;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    background-image: url($imgHost + 'box-frame.png?x-oss-process=image/resize,p_100');
    background-size: 100%;
    .nineGrid {
      width: 100%;
      height: 100%;
      >li {
        width: 100%;
        margin: 0 auto;
        display: flex;
        &+li {
          margin-top: 4px;
        }
        >div {
          flex: 1;
          text-align: center;
          position: relative;
          &+div {
            margin-left: 2px;
          }
          &.getLuck {
            height: 83px;
          }
          &.active {
            &::after {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0.5;
              border-radius: 10px;
              background-color: #000;
            }
          }
        }
        .wrapper {
          width: 100%;
          height: 83px;
          
        }
        img {
          display: block;
          height: 100%;
          width: auto;
        }
      }
    }
  }
}

.btn-group {
  position: absolute;
  right: 0;
  top: 115px;
  z-index: 99;
  .btn-item {
    width: 57px;
    height: 22px;
    background: #FFE4C4;
    border-radius: 11px;
    border-radius: 25px 0 0 25px;
    padding-left: 3px;
    box-sizing: border-box;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #CD1D24;
    margin-bottom: 10px;
    @extend .flex-center-center;
  }
}
</style>